/* vd build 2026-10-09b */
/* Viral Deals theme JS: header drawer, hero slider, product page, COD sheet. No dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function aed(cents) {
    var n = cents / 100, s = n.toFixed(2).replace(/\.00$/, '');
    var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'AED ' + p.join('.');
  }
  function aedNum(cents) { return aed(cents).replace('AED ', ''); }

  /* ---------- header drawer ---------- */
  function initDrawer() {
    var d = $('[data-vd-drawer]'); if (!d || d._vd) return; d._vd = 1;
    $$('[data-vd-menu-open]').forEach(function (b) { b.addEventListener('click', function () { d.hidden = false; document.documentElement.classList.add('vd-lock'); }); });
    $$('[data-vd-menu-close]', d).forEach(function (b) { b.addEventListener('click', function () { d.hidden = true; document.documentElement.classList.remove('vd-lock'); }); });
  }

  /* ---------- announcement rotator ---------- */
  function initRotator() {
    $$('[data-vd-rotator]').forEach(function (r) {
      var m = $$('.vd-ann__m', r); if (m.length < 2 || r._vd) return; r._vd = 1; var i = 0;
      setInterval(function () { m[i].classList.remove('is-on'); i = (i + 1) % m.length; m[i].classList.add('is-on'); }, 4500);
    });
  }

  /* ---------- hero slider ---------- */
  function initHero() {
    $$('[data-vd-hero]').forEach(function (h) {
      if (h._vd) return; h._vd = 1;
      var s = $$('.vd-hero__s', h), dots = $$('.vd-dots button', h), i = 0, t;
      if (s.length < 2) return;
      function go(n) { s[i].classList.remove('is-on'); dots[i] && dots[i].classList.remove('is-on'); i = (n + s.length) % s.length; s[i].classList.add('is-on'); dots[i] && dots[i].classList.add('is-on'); }
      function auto() { clearInterval(t); if (!reduceMotion) t = setInterval(function () { go(i + 1); }, 5500); }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); auto(); }); });
      var x0 = null;
      h.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      h.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); auto(); } x0 = null; });
      auto();
    });
  }

  /* ---------- product page ---------- */
  function initPdp() {
    var root = $('[data-vd-pdp]'); if (!root || root._vd) return; root._vd = 1;
    var P = JSON.parse($('[data-vd-json]', root).textContent);
    var endpoint = root.getAttribute('data-endpoint');
    var waNum = root.getAttribute('data-wa');
    var variant = P.variants.filter(function (v) { return v.id === P.selected; })[0] || P.variants[0];
    var vdItem = function (q) { return { id: variant.id, name: P.title, variant: P.defaultOnly ? undefined : variant.title, price: variant.price / 100, qty: q || 1, currency: 'AED' }; };
    window.vdProduct = vdItem(1);
    if (window.vdTrack) window.vdTrack('ViewContent', vdItem(1));
    var qty = 1;
    var gal = $('[data-vd-gal]', root), dots = $$('[data-vd-dots] i', root), thumbs = $$('[data-vd-thumbs] button', root);

    // gallery
    function setActive(n) {
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
      thumbs.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
    }
    if (gal) {
      gal.addEventListener('scroll', function () { var n = Math.round(gal.scrollLeft / gal.clientWidth); setActive(n); }, { passive: true });
      thumbs.forEach(function (b) { b.addEventListener('click', function () { var n = +b.getAttribute('data-i'); gal.scrollTo({ left: n * gal.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); setActive(n); }); });
    }
    function showMedia(id) {
      if (!gal || !id) return;
      var sl = $$('.vd-gal__s', gal), n = sl.findIndex(function (e) { return +e.getAttribute('data-media-id') === id; });
      if (n > -1) { gal.scrollTo({ left: n * gal.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); setActive(n); }
    }

    // render price, buttons, links
    function waLink() {
      var name = P.title + (P.defaultOnly ? '' : ' (' + variant.title + ')');
      var text = 'Hi, I want to order: ' + name + ' – AED ' + aedNum(variant.price * qty) + ', Qty ' + qty;
      return 'https://wa.me/' + waNum + '?text=' + encodeURIComponent(text);
    }
    function render() {
      try { window.vdProduct = vdItem(qty); } catch (e) {}
      var sale = variant.compare > variant.price;
      $$('[data-vd-price]', root).forEach(function (e) { e.textContent = aed(variant.price); });
      $$('[data-vd-compare]', root).forEach(function (e) { e.hidden = !sale; e.textContent = sale ? aed(variant.compare) : ''; });
      var sv = $('[data-vd-save]', root); if (sv) { sv.hidden = !sale; sv.textContent = sale ? 'You save ' + aed(variant.compare - variant.price) : ''; }
      var sp = $('[data-vd-savepill]', root); if (sp) { sp.hidden = !sale; sp.textContent = sale ? 'Save ' + Math.floor((variant.compare - variant.price) * 100 / variant.compare) + '%' : ''; }
      $$('[data-vd-segprice]', root).forEach(function (e) { e.textContent = aed(variant.price * +e.getAttribute('data-vd-segprice')); });
      $$('[data-vd-buy]', root).forEach(function (b) { b.disabled = !variant.available; b.textContent = variant.available ? 'Buy Now – Cash on Delivery' : 'Sold out'; });
      $$('[data-vd-wa]', root).forEach(function (a) { a.href = waLink(); });
      $$('[data-vd-optval]', root).forEach(function (e) { e.textContent = variant.options[+e.getAttribute('data-vd-optval')]; });
      // sheet
      var simg = $('[data-vd-simg]', root); if (simg && variant.image) simg.src = variant.image;
      var svar = $('[data-vd-svar]', root); if (svar) svar.textContent = (P.defaultOnly ? '' : variant.title + ' · ') + 'Free delivery';
      var qv = $('[data-vd-qtyv]', root); if (qv) qv.textContent = qty;
      var tot = $('[data-vd-total]', root); if (tot) tot.textContent = aed(variant.price * qty);
      $$('[data-vd-seg] button', root).forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-q') === qty); });
    }
    // options
    $$('[data-vd-opts] input', root).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var sel = $$('[data-vd-opts] fieldset', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var v = P.variants.filter(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); })[0];
        if (v) {
          variant = v; render(); showMedia(v.mediaId);
          var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
        }
      });
    });
    // quantity segment
    $$('[data-vd-seg] button', root).forEach(function (b) { b.addEventListener('click', function () { qty = +b.getAttribute('data-q'); render(); }); });

    // sticky bar: show once the main Buy Now scrolls out of view
    var mainBuy = $('.vd-buy', root), sticky = $('[data-vd-sticky]', root);
    if (mainBuy && sticky) {
      // scroll-based (an IntersectionObserver misses jumps from below the fold to above it)
      var shown = null, ticking = false;
      var upd = function () {
        ticking = false;
        var show = mainBuy.getBoundingClientRect().bottom < 0;
        if (show === shown) return; shown = show;
        sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button, a', sticky).forEach(function (e) { e.tabIndex = show ? 0 : -1; });
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd); upd();
    }

    // sheet
    var sheet = $('[data-vd-sheet]', root), ov = $('.vd-ov', root), form = $('[data-vd-form]', root);
    var lastFocus = null;
    function openSheet() {
      if (!variant.available) return;
      lastFocus = document.activeElement;
      ov.hidden = false; sheet.hidden = false; document.documentElement.classList.add('vd-lock');
      if (window.vdTrack) window.vdTrack('InitiateCheckout', vdItem(qty));
      requestAnimationFrame(function () { ov.classList.add('is-on'); sheet.classList.add('is-on'); });
      setTimeout(function () { var n = $('#vd-name', sheet); n && n.focus({ preventScroll: true }); }, 250);
    }
    function closeSheet() {
      ov.classList.remove('is-on'); sheet.classList.remove('is-on'); document.documentElement.classList.remove('vd-lock');
      setTimeout(function () { ov.hidden = true; sheet.hidden = true; }, 220);
      lastFocus && lastFocus.focus && lastFocus.focus();
    }
    $$('[data-vd-buy]', root).forEach(function (b) { b.addEventListener('click', openSheet); });
    $$('[data-vd-close]', root).forEach(function (b) { b.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
    $$('[data-vd-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () { qty = Math.max(1, Math.min(P.maxQty, qty + +b.getAttribute('data-vd-qty'))); render(); });
    });

    function normPhone(raw) {
      var p = String(raw || '').replace(/[\s\-().]/g, '');
      if (p.indexOf('00') === 0) p = '+' + p.slice(2);
      if (/^\+9715[024568]\d{7}$/.test(p)) return p;
      if (/^9715[024568]\d{7}$/.test(p)) return '+' + p;
      if (/^05[024568]\d{7}$/.test(p)) return '+971' + p.slice(1);
      if (/^5[024568]\d{7}$/.test(p)) return '+971' + p;
      return null;
    }
    function setErr(name, msg) {
      var e = $('[data-err="' + name + '"]', form); if (e) e.textContent = msg || '';
      var i = form.elements[name]; if (i) { i.classList.toggle('is-bad', !!msg); i.setAttribute('aria-invalid', msg ? 'true' : 'false'); }
    }
    function validate() {
      var f = form.elements, ok = true, first = null;
      var checks = [
        ['name', f.name.value.trim().length >= 2, 'Please enter your full name.'],
        ['phone', !!normPhone(f.phone.value), 'Enter a UAE mobile number, e.g. 05X XXX XXXX.'],
        ['emirate', !!f.emirate.value, 'Please choose your emirate.'],
        ['area', f.area.value.trim().length >= 2, 'Please enter your area.'],
        ['address', f.address.value.trim().length >= 4, 'Please enter your street, building and flat.']
      ];
      checks.forEach(function (c) { setErr(c[0], c[1] ? '' : c[2]); if (!c[1]) { ok = false; first = first || c[0]; } });
      if (first) f[first].focus();
      return ok;
    }
    $$('input, select', form).forEach(function (i) { i.addEventListener('input', function () { setErr(i.name, ''); }); });

    var busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || !validate()) return;
      var f = form.elements, btn = $('[data-vd-submit]', form), fe = $('[data-vd-formerr]', form);
      fe.hidden = true; busy = true; btn.disabled = true; btn.textContent = 'Placing your order…';
      var body = { variantId: variant.id, quantity: qty, name: f.name.value.trim(), phone: f.phone.value.trim(), emirate: f.emirate.value,
        area: f.area.value.trim(), address: f.address.value.trim(), website: f.website.value };
      fetch(endpoint.replace(/\/$/, '') + '/order', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (res) {
          if (!res || !res.ok) {
            if (res && res.fields) Object.keys(res.fields).forEach(function (k) { setErr(k, res.fields[k]); });
            fe.innerHTML = '';
            fe.appendChild(document.createTextNode((res && res.error) || 'Something went wrong. Please try again.'));
            var a = document.createElement('a'); a.href = waLink(); a.target = '_blank'; a.rel = 'noopener'; a.textContent = ' Order on WhatsApp instead';
            fe.appendChild(a); fe.hidden = false; return;
          }
          showDone(res.order, body);
        })
        .catch(function () {
          fe.textContent = 'No connection. Please check your internet and try again.';
          var a2 = document.createElement('a'); a2.href = waLink(); a2.target = '_blank'; a2.rel = 'noopener'; a2.textContent = ' Order on WhatsApp instead';
          fe.appendChild(a2); fe.hidden = false;
        })
        .finally(function () { busy = false; btn.disabled = false; btn.textContent = 'Confirm Order – Cash on Delivery'; });
    });

    function eta() {
      var fmt = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Asia/Dubai' }); };
      var a = new Date(Date.now() + 864e5), b = new Date(Date.now() + 3 * 864e5);
      return fmt(a) + ' – ' + fmt(b);
    }
    function showDone(o, body) {
      var done = $('[data-vd-done]', root);
      var set = function (k, v) { var e = $('[data-d="' + k + '"]', done); if (e) e.textContent = v; };
      var totalCents = Math.round(parseFloat(o.total) * 100);
      set('first', body.name.split(' ')[0]); set('phone', o.phone || body.phone); set('name', o.name);
      set('title', P.title); set('qty', (P.defaultOnly ? '' : variant.title + ' · ') + 'Qty ' + body.quantity);
      set('total', aed(totalCents)); set('total2', aed(totalCents)); set('to', o.deliverTo); set('eta', eta());
      var im = $('[data-d="img"]', done); if (im) im.src = variant.image || P.image;
      var wa = $('[data-d="wa"]', done);
      if (wa) wa.href = 'https://wa.me/' + waNum + '?text=' + encodeURIComponent('Hi, I have a question about my order ' + o.name + '.');
      closeSheet();
      done.hidden = false; document.documentElement.classList.add('vd-lock'); done.scrollTop = 0;
      confetti($('[data-vd-confetti]', done));
      if (window.vdTrack) window.vdTrack('Purchase', Object.assign(vdItem(+body.quantity), { value: totalCents / 100, transaction_id: o.name, order_id: o.id }));
    }
    function confetti(t) {
      if (!t || t._c) return; t._c = 1;
      var cols = ['#E6C17A', '#D88A66', '#FFFFFF', '#BFDDD5', '#C7CBDA', '#CC542C'], seed = 7;
      var r = function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
      for (var i = 0; i < 30; i++) {
        var e = document.createElement('i'); e.className = 'vd-cf';
        var w = 4 + r() * 6, h = w * (r() > .5 ? 2.2 : 1), x, y;
        do { x = r() * 100; y = r() * 100; } while (!((y < 48 && (x < 30 || x > 70)) || x < 7 || x > 93));
        e.style.cssText = 'left:' + x + '%;top:' + y + '%;width:' + w + 'px;height:' + h + 'px;background:' + cols[i % 6] + ';transform:rotate(' + (r() * 180) + 'deg);opacity:' + (.55 + r() * .45) + ';' + (r() > .6 ? 'border-radius:50%' : '');
        t.appendChild(e);
      }
    }
    render();
  }

  function init() { initDrawer(); initRotator(); initHero(); initPdp(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
